import axiosClient from '@/config/api/axios'
import { INTEGRATION_PROPOSALS } from '@/config/api/endpoints'

/** Thrown for 409: already approved, declined, expired, or mid-flight. */
export class ProposalSettledError extends Error {
  constructor(detail) {
    super(detail || 'This action is no longer waiting for approval')
    this.name = 'ProposalSettledError'
  }
}

/**
 * Approve or decline one proposed write.
 *
 * No body is sent. The arguments live in the stored row, so there is nothing
 * here that could change what gets run — approving is a decision, not a
 * request to do something slightly different.
 *
 * @param {{ proposalId: string, approved: boolean, signal?: AbortSignal }} options
 */
export async function decideProposal({ proposalId, approved, signal }) {
  const action = approved ? 'approve' : 'decline'
  try {
    const { data } = await axiosClient.post(
      `${INTEGRATION_PROPOSALS}/${proposalId}/${action}`,
      undefined,
      { signal },
    )
    return data
  } catch (error) {
    if (error?.response?.status === 409) {
      throw new ProposalSettledError(error.response.data?.detail)
    }
    throw error
  }
}
